import {
  deleteAuthenticated,
  getAuthenticated,
  patchAuthenticated,
  postAuthenticated,
} from './http';

export const fetchCompanions = ({ limit = 12, page = 1, query = '' } = {}) =>
  getAuthenticated('/companions', {
    params: { limit, page, q: query },
  });

export const fetchMyProfile = () => getAuthenticated('/companions/me/profile');

export const fetchPublicProfile = (username) =>
  getAuthenticated(`/companions/u/${encodeURIComponent(username)}/profile`);

export const updateMyProfile = (profile) =>
  patchAuthenticated('/companions/me/profile', profile);

export const touchPresence = () => postAuthenticated('/companions/presence', {});

export const searchCompanions = ({ query, limit = 8 } = {}) =>
  getAuthenticated('/companions/search', {
    params: { q: query, limit },
  });

export const fetchCompanionRequests = ({ direction = 'incoming' } = {}) =>
  getAuthenticated('/companions/requests', {
    params: { direction },
  });

export const sendCompanionRequest = (userId) =>
  postAuthenticated('/companions/requests', { userId });

export const removeCompanion = (userId) =>
  deleteAuthenticated(`/companions/${encodeURIComponent(userId)}`);

export const respondToCompanionRequest = (requestId, decision) =>
  patchAuthenticated(`/companions/requests/${requestId}/respond`, { decision });

export const cancelCompanionRequest = (requestId) =>
  deleteAuthenticated(`/companions/requests/${requestId}`);
